import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getDocumentTypes as onGetDocumentTypes,
    addNewDocumentType as onAddNewDocumentType,
    updateDocumentType as onUpdateDocumentType,
    deleteDocumentType as onDeleteDocumentType,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Payment = () => {

    //meta title
    document.title = "Paiements | SIGUNIV";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [documentType, setDocumentType] = useState(null);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            id: (documentType && documentType.id) || '',
            uid: (documentType && documentType.uid) || '',
            name: (documentType && documentType.name) || '',
            description: (documentType && documentType.description) || '',
            is_active: (documentType && documentType.is_active) || '',
            
        },
        validationSchema: Yup.object({
           
            name: Yup.string().required("Veuillez saisir le name"),
            //code: Yup.string().required("Veuillez saisir le code"),
            //series_category_id: Yup.string().required("Veuillez sélectionner la catégorie"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updateDocumentType = {
                    id: values.id,
                    uid: values.uid,
                    name: values.name,
                    description: values.description,
                    is_active: values.is_active,
                    
                };
                // update movie category
                dispatch(onUpdateDocumentType(updateDocumentType));
                validation.resetForm();
            } else {
                const newDocumentType = {
                    //id: values["id"],
                    //uid: values["uid"],
                    name: values["name"],
                    description: values["description"],
                    is_active: values["is_active"],
                   
                };
                // save new movie category
                dispatch(onAddNewDocumentType(newDocumentType));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const DocumentTypeProperties = createSelector(
        (state) => state.documentTypeReducer, 
        (documentTypeReducer) => ({
            documentTypes: documentTypeReducer.documentTypes,
            loading: documentTypeReducer.loading
        })
    );

    const {documentTypes, loading} = useSelector(DocumentTypeProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {

        console.log("ON GET documentType:");
        if (documentTypes && !documentTypes.length) {
            console.log("ON L")
            dispatch(onGetDocumentTypes());
        }
    }, [dispatch, documentTypes]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setDocumentType(null);
        } else {
            setModal(true);
        }
    };

    const handleDocumentTypeClick = arg => {
        const documentType = arg;
        setDocumentType({
            id: documentType.id,
            uid: documentType.uid,
            name: documentType.name,
            description: documentType.description,
            is_active: documentType.code,
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (branch) => {
        setDocumentType(branch);
        setDeleteModal(true);
    };

    const handleDeleteDocumentType = () => {
        if (documentType && documentType.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteDocumentType(documentType));
            setDeleteModal(false);
        }
    };

    const onClickNewDocumentType = () => {
        setIsEdit(false);
        setDocumentType(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Date",
                accessorKey: "created_at",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Réf. Inscription",
                accessorKey: "registration_id",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Montant payé",
                accessorKey: "amount_paid",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Méthode de paiement",
                accessorKey: "payment_method",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleDocumentTypeClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteDocumentType}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Paiements" breadcrumbItem="Liste des paiements" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    {/*<Link to="#!" onClick={onClickNewDocumentType} className="btn btn-primary me-1">Ajouter un type de document</Link>*/}
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={documentTypes || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Type de document" : "Ajouter - Type de document"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        <div className="mb-3">
                                            <Label>Nom</Label>
                                            <Input
                                                name="name"
                                                type="text"
                                                placeholder="Nom"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.name || ""}
                                                invalid={
                                                    validation.touched.name && validation.errors.name ? true : false
                                                }
                                            />
                                            {validation.touched.name && validation.errors.name ? (
                                                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Description</Label>
                                            <Input
                                                name="content"
                                                placeholder="Description"
                                                type="textarea"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.description || ""}
                                                invalid={
                                                    validation.touched.description && validation.errors.description ? true : false
                                                }
                                            />
                                            {validation.touched.description && validation.errors.description ? (
                                                <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                                            ) : null}
                                        </div>

                                        
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Payment;